/**
 * isMSDK
 * @author marvinqi
 * @createTime 2017/9/20
 */
import getUA from './getUA'

export default function () {
  return /\bmsdk\/([\w\.]+)/.test(getUA()) || (typeof document !== 'undefined' && document.cookie.indexOf(' GC_TICKET=') > -1)
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/isMSDK.js